import masterDataApi from "./masterDataApi";
import userApi from "./userApi";
import authApi from "./authApi";
import favoriteApi from "./favoriteApi";
import caddyApi from "./caddyApi";
import bookingApi from "./bookingApi";
import paymentApi from "./paymentApi";
import luckyDrawApi from "./luckyDrawApi";
import reviewApi from "./reviewApi";
import couponApi from "./couponApi";
import tipOfferApi from "./tipOfferApi";

const api = {
  userApi: userApi,
  masterDataApi: masterDataApi,
  authApi: authApi,
  favoriteApi: favoriteApi,
  caddyApi: caddyApi,
  bookingApi: bookingApi,
  paymentApi: paymentApi,
  luckyDrawApi: luckyDrawApi,
  reviewApi: reviewApi,
  couponApi: couponApi,
  tipOfferApi: tipOfferApi,
};

export default api;
